import { api } from '@/api';
import { config } from '@/config';

const API_ROUTES = {
    bases: {
        index:  'back.bases.fields.index',
        add:    'back.bases.fields.add',
        delete: 'back.bases.fields.delete'
    },
    eventos: {
        index:  'back.events.forms.campos-personalizados',
        add:    'back.events.forms.campos-personalizados.add',
        delete: 'back.events.forms.campos-personalizados.delete'
    },
    abonos: {
        index:  'back.abonos.forms.campos-personalizados',
        add:    'back.abonos.forms.campos-personalizados.add',
        delete: 'back.abonos.forms.campos-personalizados.delete'
    }
};

function getRoute(context, action) {
    const key = API_ROUTES[context]?.[action];
    if (!key) {
        throw new Error(`Contexto inválido: "${context}". Valores permitidos: bases, eventos, abonos`);
    }
    return config.getAPIRoute(key);
}

export const camposPersonalizadosService = {
    /**
     * Obtiene el listado de campos personalizados.
     * @param {string} context - 'bases' | 'eventos' | 'abonos'
     * @param {number|string} entityId
     * @param {object} [filters={}]
     * @returns {Promise<{data: object[], meta: object}>}
     */
    getList(context, entityId, filters = {}) {
        const route = getRoute(context, 'index');
        return api.call(route, {
            filters: { ...filters },
            lista_id: entityId
        });
    },

    /**
     * Añade campos personalizados.
     * @param {string} context
     * @param {number|string} entityId
     * @param {Array} selectedFields
     * @returns {Promise}
     */
    add(context, entityId, selectedFields) {
        const route = getRoute(context, 'add');
        return api.call(route, {
            filters: {},
            fields: selectedFields,
            lista_id: entityId
        });
    },

    /**
     * Elimina un campo personalizado.
     * @param {string} context
     * @param {number|string} entityId
     * @param {number|string} fieldId
     * @param {object} [filters={}]
     * @returns {Promise}
     */
    delete(context, entityId, fieldId, filters = {}) {
        const route = getRoute(context, 'delete');
        return api.call(route, {
            filters: { ...filters },
            lista_id: entityId,
            field_id: fieldId
        });
    },

    /**
     * Obtiene los campos disponibles para añadir (desde la configuración del teatro).
     * @param {number|string} teatroId
     * @returns {Promise}
     */
    getAvailableFields(teatroId) {
        const route = config.getAPIRoute('back.teatro.forms.to-select');
        return api.call(route, {
            filters: {},
            teatro_id: teatroId
        });
    }
};
